module.exports = __webpack_public_path__ + "img/e2.cd99abbe.png";